import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  class: "x-table"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1,
  class: "header-btn"
};
const _hoisted_4 = {
  class: "_x_table_sortable"
};
const _hoisted_5 = {
  key: 2,
  class: "x-table-pagination"
};
import global from '@/component-create/utils/global';
import { GLOBAL_DATA } from '@/component-create/utils/global-enum';
import { ElTable } from 'element-plus';
import 'element-plus/es/components/table/style/css'

import { createIconNode } from '@/component-create/utils/common';
import { log } from '@/component-create/utils/log';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import XTableColumn from './XTableColumn.vue';
import Sortable from "sortablejs";
import { DCaret } from '@element-plus/icons-vue';
import authority from '@/directive/permission/authority';

import { computed, toRefs, ref, reactive, onMounted, nextTick, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XTable',
  props: {
    column: {
      type: Array,
      default: () => []
    },
    // el-table属性
    elTableProps: Object,
    data: Array,
    url: String,
    headerButtons: [Array, Function],
    // 是否铺满
    full: {
      type: Boolean,
      default: true
    },
    // 禁用加载图显示
    disableLoaddinig: {
      type: Boolean,
      default: false
    },
    // 禁用表格数据重置后加载效果(用于无缝刷新表格数据)
    disableDataReloading: {
      type: Boolean,
      default: false
    },
    // 是否显示分页
    showPagination: {
      type: Boolean,
      default: true
    },
    // 请求数据时携带的参数
    requestData: Object,
    // 获取应用实例方法
    getInstance: Function,
    // 用户定义的事件
    handler: Object,
    // 响应数据的值
    responseConfig: {
      type: Object,
      default: () => {
        return {
          data: 'content',
          total: 'total'
        };
      }
    },
    dataFilter: Function,
    // 自动合并
    autoMerge: Boolean,
    // 是否启用选择
    selectable: Boolean,
    // 是否显示索引
    showIndex: Boolean,
    dragable: Boolean,
    autoLoad: {
      type: Boolean,
      default: true
    }
  },
  emits: ['dragEnd', 'loaded', 'select', 'select-all', 'selection-change', 'cell-mouse-enter', 'cell-mouse-leave', 'cell-contextmenu', 'cell-click', 'cell-dblclick', 'row-click', 'row-contextmenu', 'row-dblclick', 'header-click', 'header-contextmenu', 'sort-change', 'filter-change', 'current-change', 'header-dragend', 'expand-change', 'size-change', 'page-change'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const vAuthority = authority;
    const prop = __props;
    const lang = computed(() => {
      return global.globalVal['lang'] || zhCn;
    });
    const spanMethod = computed(() => {
      if (prop.autoMerge) {
        return autoSpanMethod;
      } else {
        return defaultSpanMethod;
      }
    });
    const {
      elTableProps,
      column,
      full,
      headerButtons,
      selectable,
      showIndex,
      dragable
    } = toRefs(prop);
    const tableData = ref([]);
    const REQUEST = global.globalVal[GLOBAL_DATA.TABLE_REQUEST];
    const loading = ref(false);
    const elTableRef = ref();
    const selectRows = ref([]);
    const instance = new Proxy({}, {});
    const init = ref('false');
    const customReqData = ref();
    const pagination = reactive({
      pageNumber: 1,
      pageSize: 10,
      total: 0
    });
    const emit = __emit;
    if (prop.getInstance) {
      prop.getInstance(instance);
    }
    instance.setTableData = setTableData;
    instance.load = load;
    instance.setPagination = setPagination;
    instance.setRequestData = setRequestData;
    instance.getSelectRows = getSelectRows;
    instance.getElTableInstance = getElTableInstance;
    instance.getTableData = getTableData;
    instance.setSelectRowKeys = setSelectRowKeys;
    onMounted(() => {
      instance.elTableInstance = elTableRef.value;
      init.value = 'true';
      if (prop.dragable) {
        nextTick(() => {
          rowDrop();
        });
      }
    });
    /**
     * url发送变化时自动请求
     */
    watch(() => prop.url, () => {
      if (prop.url && prop.autoLoad) {
        if (!REQUEST) {
          log('XTable', '请求失败，未配置请求服务：' + GLOBAL_DATA.TABLE_REQUEST, 'error');
        } else {
          pagination.pageNumber = 1;
          load();
        }
      }
    }, {
      immediate: true
    });
    watch(() => prop.data, () => {
      if (!prop.url) {
        setTableData(prop.data || []);
      }
    }, {
      immediate: true
    });
    function getTableData() {
      return tableData.value;
    }
    function setSelectRowKeys(keys, tableKey = 'id') {
      elTableRef.value?.clearSelection();
      keys.forEach(i => {
        const item = tableData.value.find(row => row[tableKey] === i);
        if (item) {
          elTableRef.value?.toggleRowSelection(item, true);
        }
      });
    }
    /**
     * 默认行合并
     */
    const defaultSpanMethod = () => {
      return {
        rowspan: 1,
        colspan: 1
      };
    };
    /**
     * 自动行合并
     */
    const autoSpanMethod = ({
      row,
      column,
      rowIndex,
      columnIndex
    }) => {
      const key = prop.column[columnIndex].prop;
      const mergeCondition = prop.column[columnIndex].mergeCondition;
      let rowspan = 1;
      let rIndex = rowIndex;
      let preRow = rowIndex - 1 > -1 ? tableData.value[rowIndex - 1] : null;
      let nextRow = rowIndex + 1 < tableData.value.length ? tableData.value[rowIndex + 1] : null;
      let current = tableData.value[rowIndex];
      if (!key || !prop.column[columnIndex].merge) {
        return {
          rowspan: 1,
          colspan: 1
        };
      } else if (!preRow) {
        while (nextRow && nextRow[key] === current[key] && (!mergeCondition || mergeCondition(tableData.value, nextRow, {
          row,
          column,
          rowIndex,
          columnIndex
        }))) {
          rowspan += 1;
          rIndex++;
          nextRow = rIndex + 1 < tableData.value.length ? tableData.value[rIndex + 1] : null;
        }
      } else if (preRow[key] === current[key] && (!mergeCondition || mergeCondition(tableData.value, preRow, {
        row,
        column,
        rowIndex,
        columnIndex
      }))) {
        return {
          rowspan: 0,
          colspan: 0
        };
      } else {
        while (nextRow && nextRow[key] === current[key] && (!mergeCondition || mergeCondition(tableData.value, nextRow, {
          row,
          column,
          rowIndex,
          columnIndex
        }))) {
          rowspan += 1;
          rIndex++;
          nextRow = rIndex + 1 < tableData.value.length ? tableData.value[rIndex + 1] : null;
        }
      }
      return {
        rowspan: rowspan,
        colspan: 1
      };
    };
    /**
     * 初始化拖拽
     */
    function rowDrop() {
      const tbody = (elTableRef.value?.$el).getElementsByClassName('el-table__body')[0].getElementsByTagName('tbody')[0];
      Sortable.create(tbody, {
        handle: '._x_table_sortable',
        animation: 180,
        // 结束拖拽后的回调函数
        onEnd: evt => {
          dragEndEvent(evt);
        }
      });
    }
    const reqTempData = ref({});
    /**
     * 请求表格数据
     */
    function reLoad(data, reset = true) {
      if (!data) {
        load(reqTempData.value, reset);
      } else {
        load(data, reset);
      }
    }
    function load(data, reset = true) {
      if (data) {
        reqTempData.value = data;
      }
      if (!prop.url) return;
      if (reset) {
        pagination.pageNumber = 1;
      }
      if (!prop.disableDataReloading) {
        tableData.value = [];
      }
      const reqData = {
        pageNumber: pagination.pageNumber,
        pageSize: pagination.pageSize,
        ...(prop.requestData || {}),
        ...(customReqData.value || {}),
        ...(data || {})
      };
      if (!prop.disableLoaddinig) {
        loading.value = true;
      }
      REQUEST(prop.url, reqData).then(res => {
        if (typeof prop.responseConfig.total === 'function') {
          pagination.total = prop.responseConfig.total(res.data);
        } else {
          pagination.total = res.data[prop.responseConfig.total];
        }
        if (typeof prop.responseConfig.data === 'function') {
          const resData = prop.responseConfig.data(res.data);
          // 处理过滤
          if (prop.dataFilter) {
            setTableData(prop.dataFilter(resData));
          } else {
            setTableData(resData);
          }
        } else {
          if (prop.dataFilter) {
            setTableData(prop.dataFilter(res.data[prop.responseConfig.data]));
          } else {
            setTableData(res.data[prop.responseConfig.data]);
          }
        }
        loaded();
      }).finally(() => {
        loading.value = false;
      });
    }
    /**
     * 设置请求方法
     * @param data
     */
    function setRequestData(data) {
      customReqData.value = data;
    }
    /**
     * 创建头部按钮
     * @param el VNode绘制函数
     */
    function createHeaderButton(el) {
      return el(selectRows.value, tableData.value);
    }
    /**
     * 设置表格数据
     * @param data 数据
     */
    function setTableData(data) {
      selectRows.value = [];
      tableData.value = [...data];
    }
    /**
     * 设置分页
     * @param newPagination 新分页
     */
    function setPagination(newPagination) {
      Reflect.ownKeys(newPagination).forEach(key => {
        if (key === 'pageNumber') {
          pagination.pageNumber = newPagination.pageNumber;
        }
        if (key === 'pageSize') {
          pagination.pageNumber = newPagination.pageSize;
        }
        if (key === 'total') {
          pagination.pageNumber = newPagination.total;
        }
      });
    }
    /**
     * 表格通用事件
     * @param event 事件名
     * @param args 参数
     */
    function elTableEventEmit(event, ...args) {
      if (prop.handler && prop.handler[event]) {
        prop.handler[event](...args);
      } else {
        emit(event, ...args);
      }
    }
    /**
     * 加载事件
     */
    function loaded() {
      if (prop.handler && prop.handler['loaded']) {
        prop.handler['loaded'](tableData.value);
      } else {
        emit('loaded', tableData.value);
      }
    }
    /**
     * 拖拽结束事件
     */
    function dragEndEvent(evt) {
      if (prop.handler && prop.handler['dragEnd']) {
        prop.handler['dragEnd'](evt);
      } else {
        emit('dragEnd', evt);
      }
    }
    /**
     * select选择事件
     */
    function select(selection, row) {
      selectRows.value = selection;
      if (prop.handler && prop.handler['select']) {
        prop.handler['select'](selection, row);
      } else {
        emit('select', selection, row);
      }
    }
    /**
     * 分页改变
     * @memberof Table
     */
    function handleSizeChange() {
      load(reqTempData.value, false);
      if (prop.handler && prop.handler['size-change']) {
        prop.handler['size-change'](pagination.pageSize, pagination.pageNumber);
      } else {
        emit('size-change', pagination.pageSize, pagination.pageNumber);
      }
    }
    /**
     * 分页改变
     * @memberof Table
     */
    function handleCurrentChange() {
      load(reqTempData.value, false);
      if (prop.handler && prop.handler['page-change']) {
        prop.handler['page-change'](pagination.pageSize, pagination.pageNumber);
      } else {
        emit('page-change', pagination.pageSize, pagination.pageNumber);
      }
    }
    function getElTableInstance() {
      return elTableRef.value;
    }
    /**
     * 获取选中项
     */
    function getSelectRows() {
      return selectRows.value;
    }
    __expose({
      setTableData,
      load,
      reLoad,
      getElTableInstance,
      elTableInstance: elTableRef,
      setPagination,
      setRequestData,
      getSelectRows,
      setSelectRowKeys,
      getTableData
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(lang)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_unref(headerButtons) && typeof _unref(headerButtons) === 'function' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(), _createBlock(_resolveDynamicComponent(createHeaderButton(_unref(headerButtons)))))])) : _unref(headerButtons) && _unref(headerButtons).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerButtons) || [], (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["item", {
              'first': index === 0
            }])
          }, [item.el ? (_openBlock(), _createBlock(_resolveDynamicComponent(createHeaderButton(item.el)), {
            key: 0
          })) : _createCommentVNode("", true), item.authority ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: item.type,
            icon: _unref(createIconNode)(item.icon),
            onClick: $event => item.handler(_unref(selectRows), _unref(tableData))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
            _: 2
          }, 1032, ["type", "icon", "onClick"])), [[_unref(vAuthority), item.authority]]) : _createCommentVNode("", true), !item.authority ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            type: item.type,
            icon: _unref(createIconNode)(item.icon),
            onClick: $event => item.handler(_unref(selectRows), _unref(tableData))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
            _: 2
          }, 1032, ["type", "icon", "onClick"])) : _createCommentVNode("", true)], 2);
        }), 128)), _renderSlot(_ctx.$slots, "headerButton")])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_unref(ElTable), _mergeProps({
          key: _unref(init),
          class: ["app-table", {
            'full': _unref(full)
          }],
          ref_key: "elTableRef",
          ref: elTableRef,
          data: _unref(tableData),
          "span-method": _unref(spanMethod)
        }, _unref(elTableProps) || {}, {
          style: {
            "width": "100%"
          },
          onSelect: select,
          onSelectionChange: _cache[0] || (_cache[0] = (...args) => elTableEventEmit('selection-change', ...args)),
          onSelectAll: _cache[1] || (_cache[1] = (...args) => elTableEventEmit('select-all', ...args)),
          onCellMouseEnter: _cache[2] || (_cache[2] = (...args) => elTableEventEmit('cell-mouse-enter', ...args)),
          onCellMouseLeave: _cache[3] || (_cache[3] = (...args) => elTableEventEmit('cell-mouse-leave', ...args)),
          onCellClick: _cache[4] || (_cache[4] = (...args) => elTableEventEmit('cell-click', ...args)),
          onCellDblclick: _cache[5] || (_cache[5] = (...args) => elTableEventEmit('cell-dblclick', ...args)),
          onCellContextmenu: _cache[6] || (_cache[6] = (...args) => elTableEventEmit('cell-contextmenu', ...args)),
          onRowClick: _cache[7] || (_cache[7] = (...args) => elTableEventEmit('row-click', ...args)),
          onRowContextmenu: _cache[8] || (_cache[8] = (...args) => elTableEventEmit('row-contextmenu', ...args)),
          onRowDblclick: _cache[9] || (_cache[9] = (...args) => elTableEventEmit('row-dblclick', ...args)),
          onHeaderClick: _cache[10] || (_cache[10] = (...args) => elTableEventEmit('header-click', ...args)),
          onHeaderContextmenu: _cache[11] || (_cache[11] = (...args) => elTableEventEmit('header-contextmenu', ...args)),
          onSortChange: _cache[12] || (_cache[12] = (...args) => elTableEventEmit('sort-change', ...args)),
          onFilterChange: _cache[13] || (_cache[13] = (...args) => elTableEventEmit('filter-change', ...args)),
          onCurrentChange: _cache[14] || (_cache[14] = (...args) => elTableEventEmit('current-change', ...args)),
          onHeaderDragend: _cache[15] || (_cache[15] = (...args) => elTableEventEmit('header-dragend', ...args)),
          onExpandChange: _cache[16] || (_cache[16] = (...args) => elTableEventEmit('expand-change', ...args))
        }), {
          empty: _withCtx(() => _cache[19] || (_cache[19] = [_createElementVNode("span", null, "暂无数据", -1)])),
          default: _withCtx(() => [_unref(selectable) ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            type: "selection"
          })) : _createCommentVNode("", true), _unref(showIndex) ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            type: "index",
            label: "序号",
            width: "60",
            align: "center"
          })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(column) || [], (col, index) => {
            return _openBlock(), _createBlock(XTableColumn, {
              key: index,
              col: col,
              "table-data": _unref(tableData)
            }, null, 8, ["col", "table-data"]);
          }), 128)), _renderSlot(_ctx.$slots, "default"), _unref(dragable) ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 2,
            label: "排序",
            width: "60",
            align: "center"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(DCaret))]),
              _: 1
            })])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 3
        }, 16, ["class", "data", "span-method"])), [[_directive_loading, _unref(loading)]]), __props.showPagination && _unref(pagination).total > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_pagination, {
          "current-page": _unref(pagination).pageNumber,
          "onUpdate:currentPage": _cache[17] || (_cache[17] = $event => _unref(pagination).pageNumber = $event),
          "page-size": _unref(pagination).pageSize,
          "onUpdate:pageSize": _cache[18] || (_cache[18] = $event => _unref(pagination).pageSize = $event),
          "page-sizes": [5, 10, 20, 30, 50],
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
          total: _unref(pagination).total,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total"])])) : _createCommentVNode("", true)])]),
        _: 3
      }, 8, ["locale"]);
    };
  }
});